<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @editImage="editImage"
      @purchasableApply="purchasableApplyApi"
      @fullMemberApply="fullMemberApplyApi"
      @informationReview="informationReviewApi"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template slot-scope="{ form }">
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openEditPage({ pageType: 'add' })"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <el-badge
            v-if="allow('B')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('B')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="updateDesignVisible = true"
            >
              {{ $l('INDEX.btn_change_design_name') || '企划人员调整' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
            v-if="allow('G')"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              v-if="allow('G')"
              :disabled="!checkedRowCount"
              @click="showSpecSize = true"
            >
              {{ $l('INDEX.btn_batch_update_spec') || '批量更新箱规尺寸' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
          <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
          v-if="allow('R')"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="updateCustoms"
          >
            {{ $l('btn_update_of_customs') || '批量更新报关信息' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
            v-if="allow('K')"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="updateMaterialInfo"
            >
              {{ $l('btn_batch_update_materialInfo') || '批量更新材料' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
          <el-badge
            v-if="allow('I')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('I')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="informationReview"
            >
              {{ '申请信息审核' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
          <el-badge
            v-if="allow('U')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('U')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="purchasableApply"
            >
              {{
                $l('btn_batch_submission_for_order_placement') ||
                  '批量提交转可下单'
              }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
          <!-- <el-badge
            v-if="allow('F')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('F')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="fullMemberApply"
            >
              {{ '申请转正' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge> -->
          <el-badge
            v-if="allow('J')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('J')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="updateDefaultPrice"
              :disabled="!checkedRowCount"
            >
              {{ $l('INDEX.btn_batch_modi_default_factory_price') || '批量修改默认工厂价格' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>

          <el-badge
            v-if="allow('E')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('E')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile(form)"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </template>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
      @export-success="clearCheckboxRow"
    />
    <ChangeDesign
      v-if="updateDesignVisible"
      :visible.sync="updateDesignVisible"
      @confirm="changeDesign"
    />
    <SpecSize
      :visible="showSpecSize"
      v-if="showSpecSize"
      @close="showSpecSize = false"
      @saveSpecSize="saveSpecSize"
    />
    <MaterialInfo
      :visible="showMaterialInfo"
      :detailCategoryCode="detailCategoryCode"
      v-if="showMaterialInfo"
      @close="showMaterialInfo = false"
      @saveMaterialInfo="saveMaterialInfo"
    />
    <EditImage
      :visible.sync="editSkuImageOptions.visible"
      :title="editSkuImageOptions.title"
      :amzSkuCode="editSkuImageOptions.amzSkuCode"
      @reload="reload"
    />
    <Customs
      :visible="showCustoms"
      v-if="showCustoms"
      @close="showCustoms = false"
      @saveCustoms="saveCustoms"
    />
    <DefaultFactoryPrice
      :visible="showDefaultFactoryPrice"
      :defaultFactoryScmName="defaultFactoryScmName"
      :defaultFactoryScmCode="defaultFactoryScmCode"
      v-if="showDefaultFactoryPrice"
      @close="showDefaultFactoryPrice = false"
      @saveDefaultFactoryPrice="saveDefaultFactoryPrice"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import SpecSize from '../spec-size'
import EditImage from '../edit-image'
import MaterialInfo from '../material-info'
import DefaultFactoryPrice from '../default-factory-price'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import ChangeDesign from '@/views/ecom/components/change-design'
import chooseTemplate from '@/views/ecom/components/choose-template'
import Customs from '../customs'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    ChangeDesign,
    chooseTemplate,
    SpecSize,
    EditImage,
    MaterialInfo,
    Customs,
    DefaultFactoryPrice
  },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      updateDesignVisible: false,
      showMaterialInfo: false,
      showSpecSize: false,
      showDefaultFactoryPrice: false,
      defaultFactoryScmName: '',
      defaultFactoryScmCode: '',
      showCustoms: false,
      detailCategoryCode: '',
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'ecom-sku',
        searchForm: {},
      },
      editSkuImageOptions: {
        visible: false,
        title: '编辑图片',
        amzSkuCode: '',
      },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzSkuListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-base-awsGoods-detail',
        params: { ...params, pageType },
        query,
      })
    },
    async changeDesign(form) {
      if (!this.checkedRowCount) {
        this.$message({ message: '请选择需要调整的产品', type: 'warning' })
        return
      }
      if (this.loadingOpen()) return
      const listCode = this.checkedRows.map((item) => item.amzSkuCode)
      const res = await this.$api
        .ecomAmzSkuChangeDesignApi({ listCode, ...form })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('调整失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '调整成功！',
        type: 'success',
      })
      this.reload()
      this.updateDesignVisible = false
    },
    exportFile(form) {
      const checkList =
        this.checkedRows?.map((item) => item?.amzSkuCode || '') || []
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = form || {}
      this.chooseTemplateOptions.searchForm.checkList = checkList.filter(
        Boolean
      )
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    updateDefaultPrice() {
      const checkedScmCode = Array.from(
        new Set(this.checkedRows.map((e) => e.scmCode))
      )

      if (checkedScmCode.length > 1) {
        this.$message({
          message: this.$l('tips_select_scm_too_many') || '存在不同的默认工厂',
          type: 'warning',
        })
        return
      }
      const distinctScmName = Array.from(
        new Set(this.checkedRows.map((e) => e.scmName))
      )
      this.defaultFactoryScmName = distinctScmName[0];
      this.defaultFactoryScmCode = checkedScmCode[0];
      this.showDefaultFactoryPrice = true;
    },
    updateMaterialInfo() {
      const checkedSpu = Array.from(
        new Set(this.checkedRows.map((e) => e.amzSpuCode))
      )
      if (checkedSpu.length > 1) {
        this.$message({
          message: this.$l('tips_select_spu_too_many') || '存在不同的SPU',
          type: 'warning',
        })
        return
      }
      this.detailCategoryCode = this.checkedRows[0].detailCategoryCode
      this.showMaterialInfo = true
    },
    updateCustoms() {
      const checkedSpu = Array.from(
        new Set(this.checkedRows.map((e) => e.amzSpuCode))
      )
      if (checkedSpu.length > 1) {
        this.$message({
          message: this.$l('tips_select_spu_too_many') || '存在不同的SPU',
          type: 'warning',
        })
        return
      }
      this.showCustoms = true
    },
    async saveMaterialInfo(params) {
      const amzSkuCodes = this.checkedRows.map((item) => item.amzSkuCode)
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSkuMaterialInfoSaveApi({ ...params, amzSkuCodes })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.showMaterialInfo = false
      this.reload()
      this.clearCheckboxRow()
    },
    async purchasableApplyApi(listAmzSkuCode) {
      const confirm = await this.$confirm(
        this.$l('tips_palce_order') || '是否要申请下单？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSkuPurchasableApplyApi({ listAmzSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('申请失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '申请成功！',
        type: 'success',
      })
      this.reload()
    },
    async fullMemberApplyApi(listAmzSkuCode) {
      const confirm = await this.$confirm(
        '是否要申请转正？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSkuFullMemberApplyApi({ listAmzSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('申请失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '申请成功！',
        type: 'success',
      })
      this.reload()
    },
    async informationReviewApi(listAmzSkuCode) {
      const confirm = await this.$confirm(
        '是否要信息审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSkuInformationApplyApi({ listAmzSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('申请失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '申请成功！',
        type: 'success',
      })
      this.reload()
    },
    purchasableApply() {
      if (!this.checkedRowCount) {
        this.$message({ message: '请选择需要申请可下单的SKU', type: 'warning' })
        return
      }
      const listAmzSkuCode = this.checkedRows.map((item) => item.amzSkuCode)
      this.purchasableApplyApi(listAmzSkuCode)
    },
    informationReview() {
      if (!this.checkedRowCount) {
        this.$message({
          message: '请选择需要申请信息审核的SKU',
          type: 'warning',
        })
        return
      }
      const listAmzSkuCode = this.checkedRows.map((item) => item.amzSkuCode)
      this.informationReviewApi(listAmzSkuCode)
    },
    fullMemberApply() {
      if (!this.checkedRowCount) {
        this.$message({ message: '请选择需要申请转正的SKU', type: 'warning' })
        return
      }
      const listAmzSkuCode = this.checkedRows.map((item) => item.amzSkuCode)
      this.fullMemberApplyApi(listAmzSkuCode)
    },
    
    async saveDefaultFactoryPrice(params) {
      const amzSkuCodes = this.checkedRows.map((item) => item.amzSkuCode)
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzModiDefaultFactoryPriceApi({ ...params, listSkuCode: amzSkuCodes })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.showDefaultFactoryPrice = false
      this.reload()
    },
    async saveSpecSize(params) {
      const amzSkuCodes = this.checkedRows.map((item) => item.amzSkuCode)
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSkuUpdateSizeSaveApi({ ...params, amzSkuCodes })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.showSpecSize = false
      this.reload()
    },
    async saveCustoms(params) {
      const amzSkuCodes = this.checkedRows.map((item) => item.amzSkuCode)
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSkuSpecCustomsApi({ ...params, amzSkuCodes })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.showCustoms = false
      this.clearCheckboxRow()
      this.reload()
    },
    editImage(amzSkuCode) {
      this.editSkuImageOptions = {
        visible: true,
        title: this.$l('btn_edit_image') || '编辑图片',
        amzSkuCode: amzSkuCode,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
